/**
 * `?mode=dev` only: question → question drawn the way the prototype draws it.
 *
 * An S-curve between rows (a bow out to the left lane for a row-skipping edge), with the
 * SAME label component as the production renderers — only its position differs: just above
 * the target card for a fan-out, mid-lane for a detour. Production keeps ConditionEdge /
 * SkipEdge, unchanged.
 */
import { BaseEdge, EdgeLabelRenderer, type EdgeProps } from '@xyflow/react';

import { devFlowPath } from '../../utils/edgePaths';
import type { CpaEdge } from '../../utils/projection';
import EdgeLabel from './EdgeLabel';

export default function DevFlowEdge({ id, sourceX, sourceY, targetX, targetY, style, markerEnd, data }: EdgeProps) {
  const d = data as { laneX?: number; edge?: CpaEdge } | undefined;
  const laneX = d?.edge?.lane !== undefined ? d.laneX : undefined;
  const path = devFlowPath({ x: sourceX, y: sourceY }, { x: targetX, y: targetY }, laneX);
  const lx = laneX ?? targetX;
  const ly = laneX !== undefined ? (sourceY + targetY) / 2 : targetY - 20;
  return (
    <>
      <BaseEdge id={id} path={path} style={style} markerEnd={markerEnd} />
      {d?.edge && (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan cpa-edge-label-wrap cpa-edge-label-wrap--dev"
            style={{ transform: `translate(-50%, -50%) translate(${lx}px, ${ly}px)` }}
          >
            <EdgeLabel edge={d.edge} />
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
